// extracted by mini-css-extract-plugin
export var cardHeader = "_rp-0";
export var reorderHandle = "_rp-3";
export var titleArea = "_rp-1";
export var titleAreaWithHandle = "_rp-2";